module.exports = __webpack_public_path__ + "img/email_round.83524964.svg";